const ShiftEnterDirective = function () {
    // Based on http://stackoverflow.com/questions/6014702/how-do-i-detect-shiftenter-and-generate-a-new-line-in-textarea
    function pasteIntoInput(el, text) {
        el.focus();
        if (typeof el.selectionStart == "number"
            && typeof el.selectionEnd == "number") {
            var val = el.value;
            var selStart = el.selectionStart;
            el.value = val.slice(0, selStart) + text + val.slice(el.selectionEnd);
            el.selectionEnd = el.selectionStart = selStart + text.length;
            // @ts-ignore: TS2339: Property 'selection' does not exist on type 'Document'.
        } else if (typeof document.selection != "undefined") {
            // @ts-ignore: TS2339: Property 'selection' does not exist on type 'Document'.
            var textRange = document.selection.createRange();
            textRange.text = text;
            textRange.collapse(false);
            textRange.select();
        }
    }

    function handleEnter(evt) {
        if (evt.keyCode == 13 && evt.shiftKey) {
            pasteIntoInput(this, "\n");
            evt.preventDefault();
        }
    }

    return {
        restrict: "A",
        scope: false,
        link: function (scope, element, attrs) {
            $(element).keydown(handleEnter);
        }
    }
};

export { ShiftEnterDirective };